module.exports = __webpack_public_path__ + "img/main_m_dark.55a2d95.svg";